export default function (update) {
  return new Array(update.length);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-selection@1.4.1@d3-selection/src/selection/sparse.js
// module id = 397
// module chunks = 0